<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">计算报价分</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
        </div>

        <div class="table-section">
                <el-table :data="tableData" style="width: 100%" :show-header="true" border class="bid-score-table" >
                    <el-table-column prop="no" label="NO." align="left" header-align="left" width="80">
                        <template slot-scope="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="sectionCode" label="标段编码" align="center" header-align="center"
                        min-width="120">
                    </el-table-column>
                    <el-table-column prop="sectionName" label="标段名称" align="center" header-align="center"
                        min-width="150">
                    </el-table-column>
                    <el-table-column prop="operation" label="操作" align="right" header-align="right" width="120">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleOperation(scope.row)">
                                计算报价得分
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
        </div>

        <!-- 步骤选择弹窗 -->
        <el-dialog title="选择计算步骤" :visible.sync="stepDialogVisible" width="480px" :close-on-click-modal="false" :append-to-body="true">
            <div class="step-list">
                <div v-for="step in stepList" :key="step.stepId" class="step-item">
                    <div class="step-item-left">
                        <i class="el-icon-s-operation step-item-icon"></i>
                        <span class="step-item-name">{{ step.stepName }}</span>
                    </div>
                    <el-button type="primary" size="small" @click="handleStepCalculate(step)">计算报价得分</el-button>
                </div>
                <div v-if="!stepList.length" class="step-empty">暂无可计算步骤</div>
            </div>
            <div slot="footer">
                <el-button @click="stepDialogVisible = false">取消</el-button>
            </div>
        </el-dialog>

        <!-- 投标单位选择弹窗 -->
        <el-dialog title="选择投标单位" :visible.sync="unitDialogVisible" width="70%" :close-on-click-modal="false" :append-to-body="true">
            <el-table ref="unitTable" :data="unitList" border @selection-change="handleSelectionChange" >
                <el-table-column type="selection" width="55" align="center">
                </el-table-column>
                <el-table-column type="index" label="NO." width="80" align="center">
                </el-table-column>
                <el-table-column prop="userName" label="投标单位名称" align="center">
                </el-table-column>
                <el-table-column prop="basePrice" :label="basePriceName || '基准价'" align="center">
                </el-table-column>
                <el-table-column prop="offerPrice" :label="offerPriceName || '报价'" align="center">
                </el-table-column>
                <el-table-column prop="score" label="得分" align="center">
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="unitDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleCalculateScore">计算报价得分</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/projectInfo.js'
import { getQuoteSectionList, getQuoteUnitList,getQuoteDetail } from '@/api/agent/api'
export default {
    name: 'CalculateBidScore',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            tableData: [],
            unitDialogVisible: false,
            unitList: [],
            selectedUnits: [],
            currentSectionCode: '',
            stepDialogVisible: false,
            stepList: [],
            currentStepId: null,
            offerPriceName: '',
            basePriceName: ''
        }
    },
    mounted() {
        this.getProjectInfo()
        this.getQuoteSectionList()
    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        async getQuoteSectionList() {
            const res = await getQuoteSectionList(this.projectCode)
            if (res.code === 200) {
                this.tableData = res.data
            } else {
                this.$message.error(res.msg || '操作失败')
            }

        },
        handleBack() {
            this.$router.go(-1)
        },
        // 返回项目流程界面
        handleReturn() {
            this.$router.go(-1)
        },

        // 操作按钮点击 - 先加载步骤列表
        handleOperation(row) {
            this.currentSectionCode = row.sectionCode
            this.loadStepList(row.sectionCode)
        },
        async loadStepList(sectionCode) {
            const res = await getQuoteUnitList({ sectionCode })
            if (res.code === 200) {
                this.stepList = res.data
                this.stepDialogVisible = true
            } else {
                this.$message.error(res.msg || '获取步骤列表失败')
            }
        },
        // 点击步骤的「计算报价得分」按钮 - 打开投标单位弹窗
        handleStepCalculate(step) {
            this.currentStepId = step.stepId
            this.stepDialogVisible = false
            this.getQuoteDetail()
        },
        async getQuoteDetail() {
            const res = await getQuoteDetail({
                sectionCode: this.currentSectionCode,
                stepId: this.currentStepId,
                isCalculate: 0,
                userIdList:[]
            })
            if (res.code === 200) {
                const data = res.data || {}
                this.offerPriceName = data.offerPriceName || ''
                this.basePriceName = data.basePriceName || ''
                this.unitList = Array.isArray(data.quoteList) ? data.quoteList : []
                this.unitDialogVisible = true
            } else {
                this.$message.error(res.msg || '获取单位列表失败')
            }
        },

        // 表格选择变化
        handleSelectionChange(selection) {
            this.selectedUnits = selection
        },

        // 计算报价得分
        async handleCalculateScore() {
            if (this.selectedUnits.length === 0) {
                this.$message.warning('请至少选择一个投标单位')
                return
            }
            const userIdList = this.selectedUnits.map(item => item.userId)

            const res = await getQuoteDetail({
                sectionCode: this.currentSectionCode,
                stepId: this.currentStepId,
                isCalculate: 1,
                userIdList: userIdList
            })

            if (res.code === 200) {
                this.$message.success('计算报价得分成功')
                const data = res.data || {}
                this.offerPriceName = data.offerPriceName || this.offerPriceName
                this.basePriceName = data.basePriceName || this.basePriceName
                this.unitList = Array.isArray(data.quoteList) ? data.quoteList : []
            } else {
                this.$message.error(res.msg || '计算失败')
            }
        },
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

.step-list {
    padding: 4px 0;
}

.step-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    margin-bottom: 10px;
    background: #fafafa;
    transition: background 0.15s;

    &:last-child {
        margin-bottom: 0;
    }

    &:hover {
        background: #f0f7ff;
        border-color: #c6e0ff;
    }
}

.step-item-left {
    display: flex;
    align-items: center;
    gap: 8px;
}

.step-item-icon {
    font-size: 16px;
    color: @primary-color;
}

.step-item-name {
    font-size: 14px;
    color: #303133;
    font-weight: 500;
}

.step-empty {
    text-align: center;
    padding: 30px 0;
    color: #909399;
    font-size: 13px;
}

.agent-page {
    .main-content {
        margin-top: 20px;
        overflow: hidden;
    }
}
</style>
